webpackJsonp([50739212244294],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gatsbyImage = __webpack_require__(31);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Will create a component that will list down all blog posts
	// in cards which gets passed to it.
	var BlogCard = function BlogCard(_ref) {
		var excerpt = _ref.excerpt,
		    featuredImage = _ref.featuredImage,
		    tags = _ref.tags,
		    title = _ref.title,
		    slug = _ref.slug,
		    date = _ref.date;
		return _react2.default.createElement(
			'div',
			{ className: 'blog-card' },
			_react2.default.createElement(
				'header',
				{ className: 'blog-card__header' },
				_react2.default.createElement(
					'h2',
					{ className: 'title is-4' },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: slug },
						title
					)
				),
				_react2.default.createElement(
					'p',
					{ className: 'subtitle is-6' },
					'on ' + date + ' \u2022 under',
					tags.map(function (tag) {
						return _react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/tags/' + (0, _lodash2.default)(tag) + '/',
								className: 'tag',
								key: tag
							},
							tag
						);
					})
				)
			),
			featuredImage && featuredImage.childImageSharp && featuredImage.childImageSharp.sizes ? _react2.default.createElement(
				'div',
				{ className: 'blog-card__featured-image' },
				_react2.default.createElement(
					'figure',
					{ className: 'image is-fullwidth' },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: slug },
						_react2.default.createElement(_gatsbyImage2.default, {
							sizes: featuredImage.childImageSharp.sizes,
							alt: title
						})
					)
				)
			) : null,
			_react2.default.createElement(
				'div',
				{ className: 'blog-card__content' },
				_react2.default.createElement(
					'div',
					{ className: 'content has-text-justified' },
					_react2.default.createElement(
						'p',
						null,
						excerpt
					)
				)
			),
			_react2.default.createElement(
				'footer',
				{ className: 'blog-card__footer' },
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: slug, className: 'button is-outlined is-rounded' },
					'READ MORE'
				)
			)
		);
	};
	
	BlogCard.propTypes = {
		excerpt: _propTypes2.default.string.isRequired,
		featuredImage: _propTypes2.default.shape({
			sizes: _propTypes2.default.string,
			srcSet: _propTypes2.default.string
		}),
		title: _propTypes2.default.string.isRequired,
		slug: _propTypes2.default.string.isRequired,
		tags: _propTypes2.default.arrayOf(_propTypes2.default.string),
		date: _propTypes2.default.string.isRequired
	};
	BlogCard.defaultProps = {
		featuredImage: null,
		tags: []
	};
	
	exports.default = BlogCard;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tagPageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(51);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _BlogCard = __webpack_require__(40);
	
	var _BlogCard2 = _interopRequireDefault(_BlogCard);
	
	var _Page = __webpack_require__(27);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagRoute = function (_React$Component) {
		_inherits(TagRoute, _React$Component);
	
		function TagRoute() {
			_classCallCheck(this, TagRoute);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		TagRoute.prototype.render = function render() {
			var _props = this.props,
			    _props$data = _props.data,
			    _props$data$allMarkdo = _props$data.allMarkdownRemark,
			    posts = _props$data$allMarkdo.edges,
			    totalCount = _props$data$allMarkdo.totalCount,
			    _props$data$site$site = _props$data.site.siteMetadata,
			    title = _props$data$site$site.title,
			    shortTitle = _props$data$site$site.shortTitle,
			    pageBG = _props$data.pageBG,
			    tag = _props.pathContext.tag;
	
			var tagHeader = totalCount + ' post' + (totalCount === 1 ? '' : 's') + ' tagged with \u201C' + tag + '\u201D';
	
			return _react2.default.createElement(
				_Page2.default,
				{
					title: shortTitle + ' \u2013 ' + tag,
					subtitle: tagHeader,
					hero: pageBG.childImageSharp,
					footer: _react2.default.createElement(
						'div',
						{ className: 'home-browse' },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								className: 'button is-large is-link is-outlined is-rounded',
								to: '/tags/'
							},
							'Browse all tags'
						)
					)
				},
				_react2.default.createElement(_reactHelmet2.default, { title: tag + ' | ' + title }),
				_react2.default.createElement(
					'div',
					{ className: 'columns is-desktop is-multiline' },
					posts.map(function (item) {
						var _item$node = item.node,
						    excerpt = _item$node.excerpt,
						    slug = _item$node.fields.slug,
						    _item$node$frontmatte = _item$node.frontmatter,
						    featuredImage = _item$node$frontmatte.featured_image,
						    tags = _item$node$frontmatte.tags,
						    title = _item$node$frontmatte.title,
						    id = _item$node.id;
	
						var cardProps = {
							excerpt: excerpt,
							featuredImage: featuredImage,
							tags: tags,
							title: title,
							slug: slug
						};
						return _react2.default.createElement(
							'div',
							{ className: 'column is-full', key: id },
							_react2.default.createElement(_BlogCard2.default, cardProps)
						);
					})
				)
			);
		};
	
		return TagRoute;
	}(_react2.default.Component);
	
	exports.default = TagRoute;
	
	TagRoute.propTypes = {
		data: _propTypes2.default.shape({
			site: _propTypes2.default.object.isRequired,
			allMarkdownRemark: _propTypes2.default.object.isRequired,
			pageBG: _propTypes2.default.object.isRequired
		}).isRequired,
		pathContext: _propTypes2.default.objectOf(_propTypes2.default.any).isRequired
	};
	
	var tagPageQuery = exports.tagPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-174a1710231c947f009e.js